import type { GridProps } from '@mui/material'

export const BAR_PROPS: GridProps = {
  sx: {
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    alignItems: 'center',
    gap: 1,
  },
}
